package com.partejar.app.core.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.partejar.app.core.ui.theme.PartejarShapes
import com.partejar.app.core.ui.theme.PartejarTheme

enum class PartejarStatusBadgeTone {
    NEUTRAL,
    PRIMARY,
    ACCENT,
    SUCCESS,
    ATTENTION,
    INFO,
    ERROR
}

@Composable
fun PartejarStatusBadge(
    text: String,
    modifier: Modifier = Modifier,
    tone: PartejarStatusBadgeTone = PartejarStatusBadgeTone.NEUTRAL,
    leadingContent: (@Composable RowScope.() -> Unit)? = null
) {
    val spacing = PartejarTheme.spacing
    val colors = badgeColors(tone)

    Surface(
        modifier = modifier,
        shape = PartejarShapes.pill,
        color = colors.container,
        contentColor = colors.content
    ) {
        Row(
            modifier = Modifier.padding(
                horizontal = spacing.space12,
                vertical = spacing.space4
            ),
            horizontalArrangement = Arrangement.spacedBy(spacing.space4),
            verticalAlignment = Alignment.CenterVertically
        ) {
            leadingContent?.invoke(this)
            Text(
                text = text,
                style = MaterialTheme.typography.labelMedium
            )
        }
    }
}

private data class BadgeColors(
    val container: Color,
    val content: Color
)

@Composable
private fun badgeColors(tone: PartejarStatusBadgeTone): BadgeColors = when (tone) {
    PartejarStatusBadgeTone.NEUTRAL -> BadgeColors(
        MaterialTheme.colorScheme.surfaceVariant,
        MaterialTheme.colorScheme.onSurfaceVariant
    )
    PartejarStatusBadgeTone.PRIMARY -> BadgeColors(
        MaterialTheme.colorScheme.primaryContainer,
        MaterialTheme.colorScheme.onPrimaryContainer
    )
    PartejarStatusBadgeTone.ACCENT -> BadgeColors(
        MaterialTheme.colorScheme.tertiaryContainer,
        MaterialTheme.colorScheme.onTertiaryContainer
    )
    PartejarStatusBadgeTone.SUCCESS -> BadgeColors(
        PartejarTheme.colors.successContainer,
        PartejarTheme.colors.onSuccessContainer
    )
    PartejarStatusBadgeTone.ATTENTION -> BadgeColors(
        PartejarTheme.colors.attentionContainer,
        PartejarTheme.colors.onAttentionContainer
    )
    PartejarStatusBadgeTone.INFO -> BadgeColors(
        PartejarTheme.colors.infoContainer,
        PartejarTheme.colors.onInfoContainer
    )
    PartejarStatusBadgeTone.ERROR -> BadgeColors(
        MaterialTheme.colorScheme.errorContainer,
        MaterialTheme.colorScheme.onErrorContainer
    )
}
